import { usePostMessageListener } from '@/hooks/usePostMessageListener';
import { getGenetecPostMessage } from '@/utils/helpers';
import { useCallback, useState } from 'react';

const postMessageConnection = getGenetecPostMessage({ source: 'genetec', type: 'connection' });

export const usePowerAppsHeight = () => {
  const [frameHeight, setFrameHeight] = useState(0);

  const handleResizeMessage = useCallback((props: any) => {
    const data = postMessageConnection(props);
    if (!data) return;

    if (/resize/.test(data?.event)) setFrameHeight(data?.height);
    // eslint-disable-next-line prettier/prettier
  }, []);

  usePostMessageListener(handleResizeMessage);

  return frameHeight;
};
